import { get } from "../../../System/Api/API";

const generatePrices = async (collections, deliveries, miles, roundTrip, startCountry, endCountry, clientKey, startPostcode = false, endPostcode = false) => {

        console.log("generatePrices", collections, deliveries, miles, roundTrip, startCountry, endCountry, clientKey, startPostcode, endPostcode)

        // Get the rates and tariffs
        const defaults = ( await get(`partner_settings`, null, null, ['defaultRates, setRoutes']))[0]
        const client = ( await get(`clients`, {clientKey: clientKey}))[0]
        const vtypes = await get('vehicle_types', null, [{fieldName: 'orderNo', orderDirection: 'asc'}])
        const countries = await get('countries', {'id >': '0'});

        const ukDefaultRates =  JSON.parse(defaults.defaultRates);
        const systemSetRoutes = JSON.parse(defaults.setRoutes);
        const ukClientRates =   JSON.parse(client.pricing);
        const euClientRates =   JSON.parse(client.otherPricing);
        const clientSetRoutes = JSON.parse(client.setRoutes);

        

        let clientSetRouteRates = [];
        let systemSetRouteRates = [];
        let mileagePrices = [];

        
        const calculateMileagePrices = async (clientRates = [], defaultRates = []) => {

                
                const dels = deliveries.length - 1;
                const cols = collections.length - 1;
                const prices = [];
            
                const getRateValue = (code, rateType) => {
                    if (clientRates && clientRates[`${code}${rateType}`]) {
                        return parseFloat(clientRates[`${code}${rateType}`]);
                    }
                    return parseFloat(defaultRates[`${code}${rateType}`]) || 0;
                };
            
                vtypes.forEach(v => {
                    let mileRateKey = '';
                    if (miles > 300) mileRateKey = 'Miles300';
                    else if (miles > 200) mileRateKey = 'Miles200';
                    else if (miles > 100) mileRateKey = 'Miles100';
                    else mileRateKey = 'Miles0';
            
                    const mileRate = getRateValue(v.code, mileRateKey);
                    const standingCharge = getRateValue(v.code, 'Stand');
                    const minimumCharge = getRateValue(v.code, 'Min');
                    const dropCharge = getRateValue(v.code, 'Drop');
                    const roundTripPercent = (clientRates && clientRates[`${v.code}Percent`]) || defaultRates[`${v.code}Percent`] || 1;
            
                    let totalCost = mileRate * miles + standingCharge;
                    totalCost += dropCharge * (dels + cols);
                    if (roundTrip) totalCost *= (1 + roundTripPercent / 100);
                    totalCost = Math.max(totalCost, minimumCharge);
                    totalCost = Math.ceil(totalCost).toFixed(0);
            
                    prices.push({
                        price: totalCost,
                        display: v.code,
                        ...v,
                    });
                });
            
                return prices;
        };

        const checkFixedRoutes = async (fixedRoutes, collection, delivery, roundTrip) => {

            let prices = [];
        
            const formatPostCode = (postCode, country) => {
                return country !== "GB" ? postCode.replace(/\D/g, '').toUpperCase() : postCode.toUpperCase();
            };
        
            collection.postCode = formatPostCode(collection.postCode, startCountry);
            delivery.postCode = formatPostCode(delivery.postCode, endCountry);
        
            fixedRoutes.forEach(fr => {

                
                const normalizeCountry = (country) => country.toUpperCase() === "UK" ? "GB" : country.trim().toUpperCase();
        
                fr.colCountry = fr.colCountry ? normalizeCountry(fr.colCountry) : '';
                fr.delCountry = fr.delCountry ? normalizeCountry(fr.delCountry) : '';
        
                if (fr.colCountry === startCountry && fr.delCountry === endCountry && roundTrip === fr.roundTrip) {
                    const isMatch = (routePostCode, actualPostCode) => {
                        if (routePostCode.length === 1) {
                            return actualPostCode.startsWith(routePostCode) && !isNaN(actualPostCode[1]);
                        }
                        return actualPostCode.startsWith(routePostCode);
                    };
        
                    if (isMatch(fr.collection.toUpperCase(), collection.postCode.toUpperCase()) && isMatch(fr.delivery.toUpperCase(), delivery.postCode.toUpperCase())) {
                        
                        console.log('fr', fr)
                        
                        vtypes.forEach(v => {
                            let code = v.code[0].toUpperCase() + v.code.slice(1);
                            let price = parseFloat(fr[`price${code}`]) || 0;
        
                            prices.push({  
                                price,
                                display: v.code,
                                ...v,
                            });
                        });
                    }
                }
            });
        
            return prices;
        };
        
        
        
        if (endCountry === "NIE") { endCountry = "IE" }
        if (startCountry === "NIE") { startCountry = "IE" }

        if (collections.length === 1 && deliveries.length === 1) {

            if (collections[0].postCode && deliveries[0].postCode) {
                
                clientSetRouteRates = await checkFixedRoutes(clientSetRoutes, collections[0], deliveries[0], roundTrip)
                systemSetRouteRates = await checkFixedRoutes(systemSetRoutes, collections[0], deliveries[0], roundTrip)


            } else if (startPostcode && endPostcode) {

                

                if (clientSetRoutes) {

                    clientSetRouteRates = await checkFixedRoutes(clientSetRoutes, 
                    {postCode: startPostcode}, 
                    {postCode: endPostcode}, roundTrip
                    )
                }
                

                if (systemSetRoutes) {

                    systemSetRouteRates = await checkFixedRoutes(systemSetRoutes, 
                    {postCode: startPostcode}, 
                    {postCode: endPostcode}, roundTrip
                )
                }
                
            }
        }

        if (endCountry === 'GB' && startCountry === 'GB') {

            
            // generate uk prices
            mileagePrices = await calculateMileagePrices(ukClientRates, ukDefaultRates)
            

        } else {

                const findRatesForCountry = (countryCode, rateList) => {
                        const foundRate = rateList.find(item => item.code === countryCode);
                        return foundRate ? JSON.parse(foundRate.defaultRates) : {};
                };
                
                const euDefaultRatesFound = findRatesForCountry(endCountry, countries) || findRatesForCountry(startCountry, countries);
                const clientRateEntry = euClientRates.find(item => item.countryCode === endCountry || item.countryCode === startCountry);
                const euClientRatesFound = clientRateEntry ? clientRateEntry.pricing : {};

                mileagePrices = await calculateMileagePrices(euClientRatesFound, euDefaultRatesFound);
        }

        console.group("Set routes");
        console.log('client set routes', clientSetRouteRates)
        console.log('system set routes', systemSetRouteRates)
        console.groupEnd("-----")

        console.group("Mileage prices");
        console.log('Mileage price', mileagePrices)
        console.groupEnd("-----")
        

        return {clientSetRouteRates, systemSetRouteRates, mileagePrices};

}

export default generatePrices;